import compose from 'recompose/compose';
import withMediaQueries from '../../../hocs/withMediaQueries';
import formatPrismicData from '../../../hocs/formatPrismicData';
import PromoBannerInline from './PromoBannerInline';

const enhance = compose(
  withMediaQueries,
  formatPrismicData
);

export default enhance(PromoBannerInline);



// WEBPACK FOOTER //
// ./src/client/js/view/components/DynamicLayout/PromoBannerInline/index.js